import React from 'react';
import styled from 'styled-components';

const EmptyDiv = styled.div`
    margin-bottom: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: ${props => props.theme.primary};
`

const EmptyRecord = ({message}) => {
  return (
    <EmptyDiv>
        {message}
    </EmptyDiv>
  )
}

export default EmptyRecord;